export default function WiFi() {
    return (
        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.2237 15.6636H4.93644C3.42741 15.6636 2.2041 16.8869 2.2041 18.3959V18.8688C2.2041 20.3778 3.42741 21.6012 4.93644 21.6012H22.2237C23.7328 21.6012 24.9561 20.3778 24.9561 18.8688V18.3959C24.9561 16.8869 23.7328 15.6636 22.2237 15.6636Z"
                stroke="black"
                strokeWidth="0.967802"
            />
            <path
                d="M16.9868 19.3114C17.3619 19.3114 17.6659 19.0074 17.6659 18.6323C17.6659 18.2572 17.3619 17.9531 16.9868 17.9531C16.6117 17.9531 16.3076 18.2572 16.3076 18.6323C16.3076 19.0074 16.6117 19.3114 16.9868 19.3114Z"
                fill="black"
            />
            <path
                d="M19.3637 19.3114C19.7388 19.3114 20.0429 19.0074 20.0429 18.6323C20.0429 18.2572 19.7388 17.9531 19.3637 17.9531C18.9886 17.9531 18.6846 18.2572 18.6846 18.6323C18.6846 19.0074 18.9886 19.3114 19.3637 19.3114Z"
                fill="black"
            />
            <path
                d="M21.7407 19.3114C22.1158 19.3114 22.4198 19.0074 22.4198 18.6323C22.4198 18.2572 22.1158 17.9531 21.7407 17.9531C21.3656 17.9531 21.0615 18.2572 21.0615 18.6323C21.0615 19.0074 21.3656 19.3114 21.7407 19.3114Z"
                fill="black"
            />
            <path d="M22.0763 5.86572L20.0117 15.4918" stroke="black" strokeWidth="0.967802" strokeLinecap="round" />
            <path d="M5.08284 5.86572L7.14746 15.4918" stroke="black" strokeWidth="0.967802" strokeLinecap="round" />
            <path d="M5.95312 23.6245H8.58037" stroke="black" strokeWidth="0.967802" strokeLinecap="round" />
            <path d="M18.5811 23.6245H21.2083" stroke="black" strokeWidth="0.967802" strokeLinecap="round" />
            <path
                d="M13.6102 10.385C14.0556 10.385 14.4167 10.0239 14.4167 9.57847C14.4167 9.13306 14.0556 8.77197 13.6102 8.77197C13.1648 8.77197 12.8037 9.13306 12.8037 9.57847C12.8037 10.0239 13.1648 10.385 13.6102 10.385Z"
                fill="black"
            />
            <path
                d="M17.3936 5.38845C16.3925 4.48391 15.0656 3.93311 13.6101 3.93311C12.152 3.93311 10.823 4.48587 9.82129 5.39329"
                stroke="black"
                strokeWidth="0.967802"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.7646 7.75573C15.2468 7.14413 14.4734 6.75586 13.6093 6.75586C12.7176 6.75586 11.9226 7.16926 11.4053 7.81485"
                stroke="black"
                strokeWidth="0.967802"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
